import { useQuery } from '@tanstack/react-query'
import { coinCountsApi } from '@!/Api/user'
import { userCoinKeys } from '@!/Api/queryKeys'
import { useAppCookies } from '@!/Hooks'

export const useCoinCounts = (userHash) => {
  const { coinCountsCookie } = useAppCookies()
  // cookieがあればAPIを叩かずにその値を返す（cookieが優先でAPIがフォールバック）ため、
  // 古いcookieがそのままキャッシュ値になる。それでもqueryKeyに含めるとcookieの値ごとに
  // キャッシュが分かれてしまうため意図的に含めていない
  // 設計の見直しは #4982 で対応する
  // eslint-disable-next-line @tanstack/query/exhaustive-deps
  return useQuery({
    queryKey: userCoinKeys.coinCounts(userHash),
    queryFn: async () => {
      if (userHash) {
        // cookieから取得できた場合はその値を返す
        if (coinCountsCookie) return coinCountsCookie

        // cookieから取得できなかった場合はAPIを実行する
        try {
          return await coinCountsApi()
        } catch (error) {
          console.log(error)
        }
      }

      return {}
    },
  })
}
